(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    const initializedStickyAtc = new WeakSet();

  const initStickyAtc = (root) => {
    if (!(root instanceof HTMLElement) || initializedStickyAtc.has(root)) return;

    const section = root.closest('[data-section]');
    const stickyButton = root.querySelector('[data-sticky-atc-button]');
    const primaryButton = section?.querySelector('.pdp-add-to-cart');

    if (!(stickyButton instanceof HTMLButtonElement) || !(primaryButton instanceof HTMLButtonElement)) return;

    initializedStickyAtc.add(root);

    const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    const moneyFormat = section?.dataset.moneyFormat || '';

    const setVisible = (shouldShow) => {
      const isVisible = mobileMediaQuery.matches && shouldShow;
      root.classList.toggle('is-visible', isVisible);
      root.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    };

    const syncButtonState = () => {
      const buttonLabel = primaryButton.textContent?.trim();

      stickyButton.disabled = primaryButton.disabled;

      if (buttonLabel) {
        stickyButton.textContent = buttonLabel;
      }
    };

    const formatStickyPrice = (price) => {
      if (typeof price === 'number' || /^\d+$/.test(String(price || '').trim())) {
        const cents = Number(price);

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }

        return `$${(cents / 100).toFixed(2)}`;
      }

      return price;
    };

    const updatePrice = (price) => {
      const priceElement = root.querySelector('[data-sticky-atc-price]');
      if (priceElement && price) {
        priceElement.textContent = formatStickyPrice(price);
      }
    };

    const buttonObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry) return;

        setVisible(!entry.isIntersecting);
      },
      { threshold: 0.35 }
    );

    const mutationObserver = new MutationObserver(() => {
      syncButtonState();
    });

    stickyButton.addEventListener('click', () => {
      if (!primaryButton.disabled) {
        primaryButton.click();
      }
    });

    section?.addEventListener('product:variant-change', (event) => {
      const variant = event.detail?.variant;
      syncButtonState();
      updatePrice(event.detail?.formattedPrice);

      if (!variant) {
        stickyButton.disabled = true;
      }
    });

    mobileMediaQuery.addEventListener('change', () => {
      setVisible(root.classList.contains('is-visible'));
    });

    buttonObserver.observe(primaryButton);
    mutationObserver.observe(primaryButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });

    syncButtonState();
    updatePrice(root.querySelector('[data-sticky-atc-price]')?.textContent || '');
    setVisible(false);
  };

  const mountStickyAtc = (scope = document) => {
    if (!(scope instanceof Element) && !(scope instanceof Document)) return;
    scope.querySelectorAll('[data-sticky-mobile-atc]').forEach((root) => initStickyAtc(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountStickyAtc(), { once: true });
  } else {
    mountStickyAtc();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    mountStickyAtc(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
